/** @jsxImportSource @emotion/react */
import { ErrorTemplate } from "components/templates/ErrorTemplate/ErrorTemplate";
import React from "react";

// 404ページ
export const NotFoundPage: React.FC = () => {
  return <ErrorTemplate status={404} message="NOT FOUND" />;
};
